import React from 'react';
import classNames from 'classnames';
import { IBillingOptionCheckout } from '../../../interfaces';

import styles from './PaymentTabs.module.css';

const BillingOption: React.FunctionComponent<IBillingOptionCheckout> = ({
  selfBillingMethod,
  billingMethod,
  setBillingMethod,
  children,
  disabled = false,
}) => {
  const handleOnClick = () => {
    if (disabled) return;
    setBillingMethod(selfBillingMethod);
  };
  const ariaLabel = `Select ${billingMethod} as your billing method`;
  const isSelected = selfBillingMethod === billingMethod;

  return (
    <div
      className={classNames(styles.billingOption, {
        [styles.billingOptionDisabled]: disabled,
      })}
    >
      <label htmlFor="input" className={styles.billingOptionLabel}>
        <input
          type="radio"
          value={selfBillingMethod}
          name={selfBillingMethod}
          defaultChecked={isSelected}
          hidden
          disabled={disabled}
        />
        <div
          className={classNames(styles.optionContainer, {
            [styles.optionContainerDisabled]: disabled,
          })}
          onClick={handleOnClick}
          onKeyDown={handleOnClick}
          role="button"
          aria-label={ariaLabel}
          tabIndex={0}
        >
          <div className={styles.optionContainerDot}>
            <span
              data-testid="billingOptionDot"
              className={classNames(styles.billingOptionSelect, {
                [styles.billingOptionSelected]: isSelected,
                [styles.billingOptionDotDisabled]: disabled,
              })}
            />
          </div>
          {children}
        </div>
      </label>
    </div>
  );
};

export default BillingOption;
